import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, TextField } from '@mui/material';
import React from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { UserRequest } from '../types';

const UsersSchema = Yup.object().shape({
	username: Yup.string()
		.trim()
		.required('Required')
		.max(63, 'Username too long')
		.min(8, 'Username too short'),
	firstName: Yup.string()
		.trim()
		.required('Required')
		.max(31, 'First name too long'),
	lastName: Yup.string()
		.trim()
		.required('Required')
		.max(31, 'Last name too long'),
	email: Yup.string().trim().email('Enter a valid email').required('Required'),
});

interface Props {
	initialValues: UserRequest;
	handleSubmit: SubmitHandler<UserRequest>;
	isLoading: boolean;
	isUpdate?: boolean;
	handleClose: () => void;
}

const UsersForm = (props: Props) => {
	const { initialValues, isLoading, isUpdate, handleSubmit, handleClose } =
		props;

	const { control, handleSubmit: useFormSubmit } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(UsersSchema),
		reValidateMode: 'onChange',
	});

	return (
		<Box
			sx={{ pt: 1, pb: 2 }}
			component='form'
			onSubmit={useFormSubmit(handleSubmit)}
		>
			<Stack direction='column' spacing={2} sx={{ pb: 2 }}>
				<Controller
					control={control}
					name='username'
					render={({ field, fieldState: { error } }) => (
						<TextField
							{...field}
							onChange={(event: any) => {
								const username = Yup.string()
									.lowercase()
									.transform((currentValue) =>
										currentValue.split(' ').join('-'),
									)
									.cast(event.target.value);
								field.onChange(username);
							}}
							variant='outlined'
							label='Username'
							fullWidth
							error={!!error}
							helperText={error?.message}
							disabled={isLoading || isUpdate}
						/>
					)}
				/>

				<Controller
					control={control}
					name='firstName'
					render={({ field, fieldState: { error } }) => (
						<TextField
							{...field}
							variant='outlined'
							label='First Name'
							fullWidth
							error={!!error}
							helperText={error?.message}
							disabled={isLoading}
						/>
					)}
				/>

				<Controller
					control={control}
					name='lastName'
					render={({ field, fieldState: { error } }) => (
						<TextField
							{...field}
							variant='outlined'
							label='Last Name'
							fullWidth
							error={!!error}
							helperText={error?.message}
							disabled={isLoading}
						/>
					)}
				/>

				<Controller
					control={control}
					name='email'
					render={({ field, fieldState: { error } }) => (
						<TextField
							{...field}
							variant='outlined'
							label='Email'
							type='email;'
							fullWidth
							error={!!error}
							helperText={error?.message}
							disabled={isLoading || isUpdate}
						/>
					)}
				/>
			</Stack>
			<Stack
				direction='row'
				spacing={2}
				justifyContent='flex-end'
				sx={{ mt: 2 }}
			>
				<Button onClick={handleClose} color='inherit'>
					Cancel
				</Button>
				<Button
					variant='contained'
					color='secondary'
					type='submit'
					disabled={isLoading}
				>
					{isUpdate ? 'Update' : 'Create'}
				</Button>
			</Stack>
		</Box>
	);
};

export default UsersForm;
